let lang = {
    "ca": "AD",
    "en": "GB",
    "ar": "AE",
    "ru": "RU",
    "da": "DE",
    "et": "EE",
    "el": "GR",
    "ga": "IE",
    "sl": "SI",
    "sv": "SE",
    "zh": "CN",
    "cs": "CZ",
    "ja": "JP",
    "ko": "KR"
}

let getLang = function ( iso ) {
    if(lang[iso]) {
        return lang[iso]
    } else {
        return iso
    }
}

export { getLang }


// WEBPACK FOOTER //
// ./src/misc/lang.js